// extracted by mini-css-extract-plugin
export var root = "Tags-module--root--94003";
export var showButton = "Tags-module--showButton--9b6db";
export var singleLine = "Tags-module--singleLine--86aac";
export var tag = "Tags-module--tag--165c4";
export var tagHeading = "Tags-module--tagHeading--8a1b2";
export var tags = "Tags-module--tags--69eb6";